'use client';
import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const ServiceFAQ = ({ title, faqs }) => {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <section className="py-20 bg-white border-t border-slate-100">
            <div className="w-full max-w-[800px] mx-auto px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-[#1D2B4F] mb-6">{title || "Frequently Asked Questions"}</h2>
                    <p className="text-lg text-[#5A6782]">Find answers to common questions about procurement, materials, and customization.</p>
                </div>
                
                <div className="space-y-4">
                    {faqs.map((faq, idx) => (
                        <div key={idx} className="border border-slate-200 rounded-xl overflow-hidden shadow-sm">
                            <button
                                className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-slate-50 transition-colors"
                                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                            >
                                <span className="font-bold text-left text-[#1D2B4F] text-lg">{faq.question}</span>
                                <ChevronDown className={`transform transition-transform duration-300 text-blue-600 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} />
                            </button>
                            <AnimatePresence>
                                {openIndex === idx && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        className="overflow-hidden"
                                    >
                                        <div className="px-6 pb-5 pt-2 text-[#5A6782] leading-relaxed border-t border-slate-100 bg-slate-50/50">
                                            {faq.answer}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceFAQ;
